module.exports = __webpack_public_path__ + "img/2025-0516-01-02.9543bce3.png";